import React from 'react';

interface Props {
  title?: string;
  subtitle?: string;
}

const AdminHeader: React.FC<Props> = ({ title = 'Área Administrativa', subtitle }) => {
  return (
    <div className="admin-header">
      <div className="admin-header-left">
        <a href="/" className="admin-logo-link" aria-label="Ir para página inicial">
          {/* Prefer admin-specific logo; fallback to site logo if not provided */}
          <img src="/admin-logo.png" alt="My Money" className="admin-logo" onError={(e:any) => { e.currentTarget.onerror = null; e.currentTarget.src = '/logo192.png'; }} />
        </a>
        <div>
          <h1>{title}</h1>
          {subtitle && <div className="admin-subtitle">{subtitle}</div>}
        </div>
      </div>
      <div className="admin-header-right">
        <button className="back-btn" onClick={() => (window.location.href = '/dashboard')}>← Voltar para o Perfil</button>
      </div>
    </div>
  );
};

export default AdminHeader;
